import { TransaksiKas } from './TransaksiKasPage'

export default function KasMasuk() {
  return <TransaksiKas jenis="masuk" />
}
